export const ABOUT_PAGE_PARAGRAPHS = [
  'PAGES_ABOUT_FIRST_PARAGRAPH',
  'PAGES_ABOUT_SECOND_PARAGRAPH',
  'PAGES_ABOUT_THIRD_PARAGRAPH',
  'PAGES_ABOUT_FOURTH_PARAGRAPH',
  'PAGES_ABOUT_FIFTH_PARAGRAPH',
  'PAGES_ABOUT_SIXTH_PARAGRAPH',
  'PAGES_ABOUT_SEVENTH_PARAGRAPH',
];

export const ABOUT_PAGE_IMAGES = [
  {
    path: '/static/Martin_color.png',
    description: 'Martin',
  },
  {
    path: '/static/Anet_color.png',
    description: 'Anet',
  },
  {
    path: '/static/Verca_color.png',
    description: 'Verča',
  },
  {
    path: '/static/Matej_color.png',
    description: 'Matěj',
  },
  {
    path: '/static/Bea_color.png',
    description: 'Bea',
  },
  {
    path: '/static/Lukas.png',
    description: 'Lukáš',
  },
  {
    path: '/static/Kuba.png',
    description: 'Jakub',
  },
];



// WEBPACK FOOTER //
// constants/aboutPageInfo.js